export const hexadecimalErrorMessage = "Must be a hexadecimal number";

export const hexRegex = /[0-9A-Fa-f]{32}/i;

export const isHex = (value: string) => hexRegex.test(value);

export const hexadecimalValidator = (value: string) =>
  isHex(value) ? undefined : hexadecimalErrorMessage;
